import React, { memo } from 'react';
import { Modal, Typography } from '@ann/web-components';
import { DUPLICATE_MODAL_COPY } from '../../constants/dashboardBuilderCopy';
import { Description, ModalContent } from './DuplicateDashboardModal.styled';

const DuplicateDashboardModal = ({
  open = false,
  onClose,
  onConfirm,
  dashboardName = 'Dashboard Name',
  loading = false,
}) => {
  const trimmedName = `${dashboardName || ''}`.trim();
  const displayName = trimmedName || 'Dashboard Name';

  return (
    <Modal isOpen={open} onClose={onClose} size="medium" width="900px">
      <Modal.Header/>
      <Modal.Body>
        <ModalContent>
          <Typography category="title" size="medium" weight="bold">{DUPLICATE_MODAL_COPY.title}</Typography>
          <Description>{DUPLICATE_MODAL_COPY.body(displayName)}</Description>
        </ModalContent>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button label={DUPLICATE_MODAL_COPY.cancelButton} type="secondary" onClick={onClose} />
        <Modal.Button
          label={DUPLICATE_MODAL_COPY.duplicateButton}
          type="primary"
          onClick={onConfirm}
          disabled={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default memo(DuplicateDashboardModal);
